import { MOCK_ALL_APIS } from "@/constants"
import { ExecuteCaptcha } from "./executeCaptcha.interface"
import { executeCaptcha } from "./executeCaptcha"
import { executeCaptchaMock } from "./executeCaptcha.mock"

const resolvedAction: ExecuteCaptcha = MOCK_ALL_APIS ? executeCaptchaMock : executeCaptcha
export { resolvedAction as executeCaptcha }
